import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl } from '@angular/forms';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-findfarmerdata',
  templateUrl: './findfarmerdata.component.html',
  styleUrls: ['./findfarmerdata.component.css']
})
export class FindfarmerdataComponent implements OnInit, OnDestroy {
  FormCode: UntypedFormGroup;
  constructor(private spinner: NgxSpinnerService, private fb: UntypedFormBuilder, private http: HttpClient) { }

  ngOnInit(): void { }
  ngAfterViewInit(): void {
    this.loadDataTable();
  }
  fmtext = '';
  txtSearch = '';
  dt = true;
  id_l = 1;
  h_url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/'; // เปลี่ยนเป็น URL ของ Cloud Function

  // ข้อมูลชาวไร่
  farmmerdatalist = [];
  getfarmmerdata() {
    this.spinner.show();
    let search = this.fmtext.trim();
    //let url = `farmer_basicByfmcode?text_fm=${search}`;
    let url = `${this.h_url}function-3/datatable_w`; // เปลี่ยนเป็น URL ของ Cloud Function
    const params = {
      table: `[dbo].[v_farmer_search]`,
      column: '*',
      col_like: 'fmcode,fmname',
      length: 100,
      search: search,
      orderColumn: 1,
    };
    axios.get(url, { params }).then(res => {
      this.spinner.hide();
      const data = res.data.data;
      this.farmmerdatalist = data;
      this.txtSearch = ''
    })
      .catch(err => { throw (err) });
  }
  table1: any;
  loadDataTable(): void {
    let url = `${this.h_url}function-3/datatable_w`; // เปลี่ยนเป็น URL ของ Cloud Function
    let dataTable = {
      table: `[dbo].[v_farmer_search]`
      , col_like: 'fmcode_b1,fmname'
    }
    let self = this; // ใช้ self เพื่อให้สามารถเรียก method ภายใน class ได้
    if (this.table1) {
      this.table1.destroy(); // ทำลายตารางเก่า ถ้ามี
    }
    this.table1 = $('#datatable').DataTable({
      processing: true,
      serverSide: true,
      paging: true, // ✅ เปิดใช้งาน Pagination
      searching: true, // ✅ เปิดใช้งาน Search
      ordering: true, // ✅ เปิดใช้งาน Sorting

      //lengthMenu: [5, 10, 25, 50], // ✅ ตั้งค่าจำนวนรายการต่อหน้า
      ajax: (data, callback) => {
        $('#loadingIndicator').show(); // แสดงตัวโหลดก่อนเรียก API
        const params = {
          table: dataTable.table,
          col_like: dataTable.col_like,
          start: (data as any).start,
          length: (data as any).length,
          search: (data as any).search.value,
          orderColumn: (data as any).columns[(data as any).order[0].column].data,
          orderDir: (data as any).order[0].dir,
          draw: (data as any).draw
        };

        this.http.get(url, { params }).subscribe((resp: any) => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
          $('#loadingIndicator').hide(); // ซ่อนตัวโหลดหลังจากโหลดเสร็จ
        }, () => {
          $('#loadingIndicator').hide(); // ซ่อนตัวโหลดในกรณีเกิดข้อผิดพลาด
        });
      },
      columns: [
        { data: 'fmcode_b1', title: 'โควตา' },
        { data: 'fmname', title: 'ชื่อ', className: 'text-left' },
        { data: 'tel', title: 'เบอร์โทร', },
        {
          data: null, title: `ที่อยู่`
          , orderable: false, className: 'text-left',
          render: function (data: any, type: any, row: any) {
            return `บ้านเลขที่ ${row.homeno || ''} หมู่ ${row.moo || ''} บ้าน${row.namemoo || ''} <br>
            ต.${row.district || ''} อ.${row.county || ''} จ.${row.province || ''}`;
          }
        },
        { data: 'supzone', title: 'โซน', },
        { data: 'supcode', title: 'นสส', },
        { data: 'groupcode', title: 'กลุ่ม', },
        {
          data: null, title: `63/64 <br> พื้นที่/อ้อยเข้า/yield`,
          orderable: false, className: 'text-center',
          render: function (data: any, type: any, row: any) {
            return `${self.formatNumber(row.area6364, 1, 2)}/${self.formatNumber(row.wgt6364, 1, 2)}/${self.formatNumber(row.yield6364, 1, 2)}`;
          }
        },
        {
          data: null, title: `64/65 <br> พื้นที่/อ้อยเข้า/yield`,
          orderable: false, className: 'text-center',
          render: function (data: any, type: any, row: any) {
            return `${self.formatNumber(row.area6465, 1, 2)}/${self.formatNumber(row.wgt6465, 1, 2)}/${self.formatNumber(row.yield6465, 1, 2)}`;
          }
        },
        {
          data: null, title: `65/66 <br> พื้นที่/อ้อยเข้า/yield`,
          orderable: false, className: 'text-center',
          render: function (data: any, type: any, row: any) {
            return `${self.formatNumber(row.area6566, 1, 2)}/${self.formatNumber(row.wgt6566, 1, 2)}/${self.formatNumber(row.yield6566, 1, 2)}`;
          }
        },
        {
          data: null, title: `66/67 <br> พื้นที่/อ้อยเข้า/yield`,
          orderable: false, className: 'text-center',
          render: function (data: any, type: any, row: any) {
            return `${self.formatNumber(row.area6667, 1, 2)}/${self.formatNumber(row.wgt6667, 1, 2)}/${self.formatNumber(row.yield6667, 1, 2)}`;
          }
        },
        {
          data: null, title: `67/68 <br> พื้นที่/อ้อยเข้า/yield`,
          orderable: false, className: 'text-center',
          render: function (data: any, type: any, row: any) {
            return `${self.formatNumber(row.area6768, 1, 2)}/${self.formatNumber(row.wgt6768, 1, 2)}/${self.formatNumber(row.yield6768, 1, 2)}`;
          }
        },
        {
          data: null, title: `68/69 <br> พื้นที่/อ้อยเข้า/yield`,
          orderable: false, className: 'text-center',
          render: function (data: any, type: any, row: any) {
            return `${self.formatNumber(row.area6869, 1, 2)}/${self.formatNumber(row.wgt6869, 1, 2)}/${self.formatNumber(row.yield6869, 1, 2)}`;
          }
        },
      ]
    });
  }

  formatNumber(value: number, a: number, b: number): string {
    if (value) {
      return new Intl.NumberFormat('en-US', { minimumFractionDigits: a, maximumFractionDigits: b }).format(value);
    }
    else return '0'
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.farmmerdatalist = null;
  }
}
